import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCustomMask]'
})
export class CustomMaskDirective {
  private lastValue = ''; // Guarda el último valor para comparar cambios

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnInit() {
    this.setInitialValue();
  }

  setInitialValue() {
    this.el.nativeElement.value = '000/000/000'; // Establece el valor inicial con las diagonales en su lugar
    this.lastValue = this.el.nativeElement.value;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const cursorPos = this.el.nativeElement.selectionStart; // Obtiene la posición actual del cursor
    const newValue = this.ensureDiagonals(value); // Asegura las diagonales
    this.el.nativeElement.value = newValue; // Establece el nuevo valor

    // Calcula la nueva posición del cursor
    const diff = newValue.length - this.lastValue.length;
    const newCursorPos = cursorPos + diff;
    this.setPosition(Math.max(newCursorPos, 0)); // Ajusta la posición del cursor

    this.lastValue = newValue; // Actualiza el último valor
  }

  ensureDiagonals(value: string): string {
    // Extrae solo los números del valor de entrada
    let numbers = value.replace(/\D/g, '').padEnd(9, '0');
    // Reconstruye el valor con las diagonales en las posiciones correctas
    return `${numbers.substring(0, 3)}/${numbers.substring(3, 6)}/${numbers.substring(6, 9)}`;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const cursorPos = this.el.nativeElement.selectionStart;
    if ((event.key === 'Backspace' && (cursorPos === 4 || cursorPos === 8)) || event.key === '/') {
      event.preventDefault(); // Previene el borrado de las diagonales
    }
  }

  private setPosition(position: number) {
    setTimeout(() => {
      this.el.nativeElement.setSelectionRange(position, position);
    });
  }
}
